import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import IntlMessage from "../components/util-components/IntlMessage";
import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import moment from 'moment'

import MultiAssocForm2 from "../components/custom-fields/MultiAssocForm2";
import PermissionAlert from "../components/permissions/PermissionAlert";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalPayement extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        compte: null,
        facturation: null,
        types: [],
        type: null,
        step: 0
    };

    state = this.initstate

    async show(id, typeId = null) {
        console.log("USER PAYEMENT ", id)

        this.setState({visible: true, loading: true})

        var res = await ApiService.get("/users/full/" + id)
        console.log(res)

        if (res.success) {
            var facturation = null
            if (res.compte.facturations.length > 0) {
                facturation = res.compte.facturations[0]
            }

            this.setState({compte: res.compte, facturation: facturation, step: 1})

            var res2 = await ApiService.get("/paiements/manual/types/" + id)
            console.log(res2)

            if (typeId) {
                const item = res2.items.find(i => i.value == typeId)
                if (item) {
                    this.setState({step: 2, type: item})
                }
            }

            this.setState({loading: false, types: res2.items})

        } else {
            this.close()
        }

    }

    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        if (!data.facturation || !this.state.compte || !this.state.type) {
            return false
        }

        var config = {
            type: this.state.type.type,
            typeId: this.state.type.value,
            compte: this.state.compte.id,
            facturation: this.state.compte.facturations.find(i => i.id == data.facturation),
            montant: data.montant,
            method: data.method,
            datetime: data.datetime.toDate(),
            cerfa: data.cerfa,
            commentaire: data.commentaire || null,
            assoc: data.assoc || "MAIN"
        }

        if (this.state.type.type == "SERVICE") {
            config.service = this.state.type.data
            config.service.nom = data.nom
            config.service.prenom = data.prenom
        }

        var res = await ApiService.post("/paiements/manual/create/", config)
        console.log(res)

        if (res.success) {
            notification.success({
                message: (<IntlMessage id="success.add"/>)
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: (<IntlMessage id="error.add"/>)
            })
        }
    }


    render() {


        return (
            <Fragment>
                <Modal width={"100%"} style={{minHeight: 500}} title={"Enregistrer un Paiement"}
                       open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>
                    <PermissionAlert permissions={["paiement.add"]}>
                        <Steps current={this.state.step} status={this.state.loading ? "wait" : "process"}>
                            <Steps.Step title="Compte"
                                        description={this.state.compte ? this.state.compte.nom + " " + this.state.compte.prenom : null}/>
                            <Steps.Step title="Raison" description={this.state.type ? this.state.type.label : null}/>
                            <Steps.Step title="Informations du Paiement" description=""/>
                        </Steps>

                        {this.state.step == 1 && (
                            <Form style={{margin: "50px 0px"}}>
                                <Form.Item
                                    label="Raison du Paiement"
                                    name="raison"
                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                >
                                    <Select style={{width: "100%"}} placeholder="Raison du Paiement"
                                            onChange={(value) => {
                                                const item = this.state.types.find(i => i.value == value)
                                                this.setState({step: 2, type: item})
                                            }}>
                                        {this.state.types.map((item, index) => {
                                            return <Option key={index} value={item.value}>{item.label}</Option>
                                        })}
                                    </Select>
                                </Form.Item>
                            </Form>
                        )}


                        {this.state.step == 2 && (
                            <div style={{margin: "50px 50px"}}>
                                <Form
                                    initialValues={{
                                        nom: this.state.compte?.nom,
                                        prenom: this.state.compte?.prenom,
                                        datetime: moment(),
                                        cerfa: this.state.type?.type == "SERVICE" ? this.state.type?.data?.cerfa : true,
                                        facturation: this.state.facturation ? this.state.facturation.id : null,
                                        montant: this.state.type?.type == "DETTE" ? this.state.type?.data?.reste : this.state.type?.type == "SERVICE" ? this.state.type?.data?.montant : null,
                                    }}
                                    onFinish={(data) => this.onFinish(data)}
                                >
                                    {this.state.type?.type == "SERVICE" && (
                                        <Fragment>
                                            <Divider>Bénéficiaire du Service</Divider>
                                            <Row justify="space-around" align="center">

                                                <Form.Item
                                                    label="Nom"
                                                    name="nom"
                                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                >
                                                    <Input placeholder="Nom"/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Prenom"
                                                    name="prenom"
                                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                >
                                                    <Input placeholder="prenom"/>
                                                </Form.Item>
                                            </Row>
                                            <Divider/>
                                        </Fragment>
                                    )}

                                    <Form.Item
                                        label="Adresse de Facturation"
                                        name="facturation"
                                        rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                    >
                                        <Select style={{width: 500, maxWidth: "80vw"}}
                                                placeholder="Adresse de Facturation">
                                            {this.state.compte?.facturations.length > 0 && this.state.compte.facturations.map((item, index) => {
                                                return (
                                                    <Option key={index} value={item.id}>
                                                        <Text>{item.name}</Text><br/>
                                                        <Text
                                                            type="secondary">{item.raison} {item.civilite} {item.nom} {item.prenom}</Text><br/>
                                                        <Text
                                                            type="secondary">{item.adresse} - {item.postal} {item.ville},{item.pays}</Text>
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    </Form.Item>


                                    <Form.Item
                                        label="Moyen de Paiement"
                                        name="method"
                                        rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                    >
                                        <Select placeholder="Moyen de Paiement">
                                            <Option value="CHEQUE">Chèque</Option>
                                            <Option value="VIREMENT">Virement Bancaire</Option>
                                            <Option value="CASH">Espèces</Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label="Montant"
                                        name="montant"
                                        rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                    >
                                        <InputNumber
                                            decimalSeparator={','} step={0.5}
                                            max={this.state.type?.type == "DETTE" ? this.state.type?.data?.reste : null}
                                            formatter={value => `${value}€`}
                                            parser={value => value.replace('€', '').replace(",", ".")}
                                        />
                                    </Form.Item>


                                    <Form.Item
                                        label="Date du paiement"
                                        name="datetime"
                                        rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                    >
                                        <DatePicker showTime format="DD/MM/YYYY HH:mm"/>
                                    </Form.Item>


                                    <Form.Item
                                        label="Cerfa"
                                        name="cerfa"
                                    >
                                        <Switch
                                            defaultChecked={this.state.type?.type == "SERVICE" ? this.state.type?.data?.cerfa : true}/>
                                    </Form.Item>


                                    <Form.Item
                                        label="Commentaire"
                                        name="commentaire"
                                    >
                                        <Input.TextArea/>
                                    </Form.Item>


                                    <MultiAssocForm2/>

                                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                            Valider
                                        </Button>
                                    </Form.Item>

                                </Form>
                            </div>
                        )}
                    </PermissionAlert>
                </Modal>
            </Fragment>

        )
    }
}

